import React, { useContext, useEffect, useState } from "react";
import { applyChartTheme } from "../utils/chart-theme";
import { applyColorMode, ColorMode, readColorMode, writeColorMode } from "../utils/color-mode";

interface ColorModeContextValue {
  mode: ColorMode;
  setMode: (mode: ColorMode) => void;
}

const ColorModeContext = React.createContext<ColorModeContextValue>({
  mode: "light",
  setMode: () => {},
});

function ColorModeProvider(props: { children: React.ReactNode }) {
  const [mode, setModeState] = useState<ColorMode>(readColorMode);

  useEffect(() => {
    applyColorMode(mode);
    applyChartTheme(mode);
  }, [mode]);

  const setMode = (next: ColorMode) => {
    writeColorMode(next);
    applyChartTheme(next);
    setModeState(next);
  };

  return <ColorModeContext.Provider value={{ mode, setMode }} {...props} />;
}

function useColorMode() {
  return useContext(ColorModeContext);
}

export { ColorModeProvider, useColorMode };
